import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Modal} from 'antd';
import NewFolderModel from "./NewFolderModel";
import BaseComponent from "../../../base/BaseComponent";
import rename from '../view/Resource/img/edit-outlined.png'
import Share from "./Share";
import {uuid} from "../../../utils";
import CmForm from "../../../components/CmForm/CmForm";
import CandidateComponents from "../../components/treeModuleBySelectPerson/CandidateComponents";
import {message} from './Mess'


export default class Partake  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            management:false,
            candidateComponentsKey: uuid(),
          
        }
    }

    componentWillMount() {
    }
    componentDidMount() {
    }

    render() {
        let right =  this.props.marginRight?this.props.marginRight: 5;
        return(
            <div >
                <div style={{marginRight:right,cursor: "pointer"}}> {this.props.text?<span  onClick={()=> {
                    this.showModalShare()
                }}>分享</span>:<Button  icon={"share-alt"} onClick={()=>this.showModalShare()}>分享</Button>}</div>
                {this.renderModel()}
            </div>

        )
    }
    renderModel(){
        return(
            <Modal
                maskClosable={false}
                keyboard={true}
                title="分享"
                visible={this.state.management}
                centered
                key={uuid()}
                width={800}
                onOk={()=>{
                    this.setupAdministrator()
                }}
                onCancel={()=>{
                    this.setState({management:false})
                }}>

                    <div
                        style={{display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',}}
                    >
                        {this.state.management?
                            <CandidateComponents key={this.state.candidateComponentsKey}  deptId={'0'} ref={(CandidateComponents)=>{this.CandidateComponents=CandidateComponents}} />
                        :null}
                    </div>
               
            </Modal>
        )
    }
    // 分享的弹框
    showModalShare() {
        if(this.props.checkArray.length){
            let num =0;
            this.props.checkArray&&this.props.checkArray.length&&this.props.checkArray.forEach((item,index)=>{
                if(item.extendedAttributeJson&&item.extendedAttributeJson.download){
                  num++
                }
            });
            if(num>0){
                message.error('所选资源中，存在需要申请下载的资源，请重新选择！');
                return  false
            }else{
                this.setState({management:true})
            }
        }else{
            message.error('至少选择一个文件夹或者文件！')
        }

    };

    setupAdministrator(){
        let createDeptName=[];
        window.currentUser.deptList&& window.currentUser.deptList.length&& window.currentUser.deptList.forEach((item=>{
            createDeptName.push(item.name)
        }));
        this.CandidateComponents.getSelectList((selectList)=>{
            console.log(selectList,'selectList')
            let parms=[];
            if(selectList.length){
                this.props.checkArray&&this.props.checkArray.length&&this.props.checkArray.forEach((item,index)=>{

                    selectList&&selectList.length&&selectList.forEach((Item,ids)=>{
                        let id =[];
                        Item.deptList&&Item.deptList.length&&Item.deptList.forEach((i,index)=>{
                            if(Item.deptName[0]=== i.name){
                                id.push(i.id)
                            }
                        });
                            parms.push({
                            virtualFileId:item.virtualFileId?item.virtualFileId:item.id,
                            creator:window.currentUser.id,
                            creatorName:window.currentUser.name ,
                            createDeptId: window.currentUser.deptIds.join(',') ,
                            createDeptName:createDeptName.join(','),
                            shareAccount:Item.id,
                            shareName:Item.name,
                            shareDeptId:id.join(','),
                            shareDeptName:Item.deptName.join(','),
                        })
                    })
                });
                this.request({
                    url: "/cm-sites-storage-management/zykShare/add",
                    method: "post",
                    body: parms,
                    contentType: "json",
                    callBack: (data) => {
                        if(data){
                            message.success('分享成功');
                            // this.props.callBack&&this.props.callBack(this.props.currentId, this.props.current,[],true);
                            this.props.callBack&&this.props.callBack()
                            this.setState({management:false})
                        }else{
                            message.error('分享失败！')
                        }

                    }
                });
            }else{
                message.error('请至少选择一个要分享的部门或对象！')
            }
        })

    }



}
